import { i18n } from "./../i18n";
import { createApp } from "vue";

const app = createApp();

app.use(i18n);

app.component("faq", require("./../client/views/Faq.vue").default);

app.mount("#app");
